<template>
    <img :src="bannerInfo.thumbnail | resizeThumbnail({width:750, height: 420})" alt=""
         class="multi-banner-item">
</template>

<script>
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'MultiBannerItem',
  props: ['bannerInfo'],
  filters: {
    resizeThumbnail
  }
}
</script>

<style scoped>
  .multi-banner-item {
    width: 100%;
  }
</style>
